import axios from "axios";
import { CPDPoints } from "components/CPDPoints";
import renderExperts from "components/Dashboard/renderExperts";
import renderPartners from "components/Dashboard/renderPartners";
import renderSponsorCheckbox from "components/Dashboard/renderSponsorCheckbox";
import renderSponsors from "components/Dashboard/renderSponsors";
import Checkbox from "material-ui/Checkbox";
import { FormControl, FormControlLabel } from "material-ui/Form";
import Radio, { RadioGroup } from "material-ui/Radio";
import moment from "moment";
import React, { PropTypes } from "react";
import WebinarSponsorsRepresentative from "../../../WebinarSponsorsRepresentative";
import { connect } from "react-redux";
import { noImagePlaceholder } from "../../../../constants/baseConst";

class UpcomingWebinarItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      is_subscription_sponsor: this.props.webinar.is_subscription_sponsor,
    };
  }

  render() {
    const {
      webinar,
      subscriptions,
      userRole,
      user,
      toggleSubscription,
      onSubscriptionChange,
      toggleSponsorsSubscription,
      noTitle,
      openAddToCalendarModal,
    } = this.props;
    const isIndustryWebinar =
      Array.isArray(webinar.user_types) &&
      webinar.user_types.length === 1 &&
      webinar.user_types[0] === 11;
    const canRegister =
      userRole !== "sponsor" ||
      (user.sponsor_type === "pharmaceutical" && isIndustryWebinar);
    const {
      webinar_title,
      start_date,
      end_date,
      sponsor,
      sponsors,
      partnerships,
      subscription_id,
      experts,
      sessions,
      id,
    } = webinar;

    const { logo_url, title } = this.props.currentGroup;

    const { subscriptionEvents, is_subscription_sponsor } = this.state;
    const subscriptionLabel =
      subscriptionEvents &&
      subscriptionEvents[webinar.id] &&
      subscriptionEvents[webinar.id].length
        ? "Confirm selection"
        : "Click here to select breakout rooms";

    if (noTitle)
      return (
        <div className="section_previous noTitle">
          <div className="content">
            <div>
              <p className="section_topic">{webinar_title}</p>
              <p className="current_card_date">
                <span>{moment(start_date).format("dddd").toUpperCase()} </span>
                <span>
                  {moment(start_date).format("DD MMMM YYYY").toUpperCase()}{" "}
                </span>
                {/*{moment(start_date).format('YYYY')}*/}
              </p>
              <p className="current_card_time">
                {moment(start_date).format("h:mm a").toUpperCase()}
                {" - "}
                {moment(end_date).format("h:mm a").toUpperCase()}
              </p>
            </div>
            <div className="col l2">
              <img
                className="group-card-image"
                src={logo_url || noImagePlaceholder}
              />
              <h6 style={{ textAlign: "center" }}>{title}</h6>
            </div>
            <div>
              {sponsors && sponsors.length && sponsors.length > 0 ? (
                <div>
                  <p>Brought to you by:</p>
                  {renderSponsors(sponsor, sponsors, noTitle)}
                </div>
              ) : null}
              {partnerships &&
              partnerships.length &&
              partnerships.length > 0 ? (
                <div>
                  <p>In partnership with:</p>
                  {renderPartners(partnerships, noTitle)}
                </div>
              ) : null}
            </div>
          </div>
          <div className="experts">{renderExperts(experts, noTitle)}</div>
        </div>
      );

    return (
      <div className="section_previous" id={`upcoming${id}`}>
        <p className="section_topic">{webinar_title}</p>
        <div className="section_info row">
          <div className="col l3 webinar_title">
            <p className="section_previous_theme"></p>
            {partnerships && partnerships.length && partnerships.length > 0 ? (
              <div>
                <p>In partnership with:</p>
                {renderPartners(partnerships)}
              </div>
            ) : null}
          </div>
          {webinar && webinar.document_url ? (
            <div className="col l1">
              <div className="current_points">
                Agenda:
                <a
                  className="download_attachment"
                  target="_blank"
                  href={webinar.document_url}
                >
                  Download
                </a>
              </div>
            </div>
          ) : null}
          {/* {Boolean(webinar.sponsor_representative.length) && (
            <div className="col l2">
              <WebinarSponsorsRepresentative
                sponsors={webinar.sponsor_representative}
              />
            </div>
          )} */}
          <div className="col l2 section_topic">
            <p className="current_card_date">
              <span>{moment(start_date).format("dddd").toUpperCase()} </span>
              <span>
                {moment(start_date).format("D/M/YYYY").toUpperCase()}{" "}
              </span>
              {/*{moment(start_date).format('YYYY')}*/}
            </p>
            <p className="current_card_time">
              {moment(start_date).format("h:mm a").toUpperCase()}
              {" - "}
              {moment(end_date).format("h:mm a").toUpperCase()}
            </p>
          </div>
          <div className="col l2">
            <img
              className="group-card-image"
              src={logo_url || noImagePlaceholder}
            />
            <h6 style={{ textAlign: "center" }}>{title}</h6>
          </div>
          <div className="col l2">
            {sponsors && sponsors.length && sponsors.length > 0 ? (
              <div>
                <p>Brought to you by:</p>
                {renderSponsors(sponsor, sponsors, false)}
              </div>
            ) : null}
          </div>
          {webinar && webinar.cpd_points ? (
            <div className="col l1">
              <div className="current_points">
                <CPDPoints webinar={webinar} />
              </div>
            </div>
          ) : null}

          <div className="col l2">
            <div className="current_join">
              {canRegister && (
                <button
                  className={`${subscription_id ? "" : "register-interest"} ${
                    !subscription_id ? "webinar-events-show" : ""
                  }`}
                  onClick={() => {
                    toggleSubscription();
                  }}
                >
                  {!!(sessions && sessions.length) &&
                    (subscription_id
                      ? "Breakout room selected"
                      : subscriptions &&
                          subscriptions[webinar && webinar.id] &&
                          subscriptions[webinar && webinar.id].length
                        ? "Click HERE to confirm selection"
                        : "Click here to select BREAKOUT ROOMS")}
                  {!(sessions && sessions.length) &&
                    (subscription_id ? "REGISTERED" : "REGISTER")}
                </button>
              )}

              <div style={{ marginTop: "10px" }}>
                <div
                  onClick={openAddToCalendarModal}
                  style={{
                    position: "inherit",
                    color: "#039be5",
                    cursor: "pointer",
                  }}
                >
                  Add To Calendar
                </div>
              </div>

              {webinar.subscription_sponsor ? (
                <div className="email_notification_sponsor">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={is_subscription_sponsor}
                        name="subscription_sponsor"
                        onChange={() => {
                          this.setState({
                            ...this.state,
                            is_subscription_sponsor:
                              !this.state.is_subscription_sponsor,
                          });
                          axios.put(
                            "/api/v1/subscription_sponsors/" + webinar.id,
                          );
                        }}
                      />
                    }
                    label={
                      <span className="email_notification_label">
                        <div className="checkbox-sponsor">
                          Check the box if you like to be kept informed about
                          future Masterclasses from
                          {/* <div className="sponsor_name_check">
                            {sponsor && sponsor.title && <p>{sponsor.title}</p>}
                          </div> */}
                          {/* {sponsors &&
                          sponsors.length &&
                          sponsors.length > 0 ? (
                            <div>
                              {renderSponsorCheckbox(sponsor, sponsors)}
                            </div>
                          ) : null} */}
                        </div>
                      </span>
                    }
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        {renderExperts(experts)}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentGroup: state.studygroups.studygroup,
  user: state.users.user,
});

const mapDispatchToProps = (dispatch) => ({});

UpcomingWebinarItem.propTypes = {
  webinar: PropTypes.obj,
  toggleSubscription: PropTypes.obj,
  userRole: PropTypes.string,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpcomingWebinarItem);



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/Webinars/Upcoming/UpcomingWebinarItem.js